import { LazyImage, styled } from '@teko/ds-desktop';
import React, { MouseEvent } from 'react';
import { ProductImage } from 'types';

interface ImageZoomStyledProps {
  image?: ProductImage;
  onClick?: () => void;
  height?: number;
  width?: number;
}

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  cursor: zoom-in;
  border-width: 1;
  border-color: rgba(0, 0, 0, 0.06);
  border-style: solid;
  border-radius: 8px;
  aspect-ratio: 1;

  &::after {
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 1.5rem;
    color: #333;
    pointer-events: none;
  }
`;

const ImageZoomStyled: React.FC<ImageZoomStyledProps> = ({
  image,
  width,
  height,
  onClick,
}) => {
  const handleMouseOver = (e: MouseEvent<HTMLDivElement>) => {
    const wrapper = e.currentTarget;
    const scale = wrapper.getAttribute('data-scale') || '1';
    const img = wrapper.querySelector('div') as HTMLDivElement | null;
    if (img) img.style.transform = `scale(${scale})`;
  };

  const handleMouseOut = (e: MouseEvent<HTMLDivElement>) => {
    const img = e.currentTarget.querySelector('div') as HTMLDivElement | null;
    if (img) {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = '';
    }
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const wrapper = e.currentTarget;
    const img = wrapper.querySelector('div') as HTMLDivElement | null;
    if (!img) return;

    const rect = wrapper.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
  };

  return (
    <ImageWrapper
      data-scale={2.0}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onMouseMove={handleMouseMove}
    >
      <LazyImage
        contain
        {...image}
        height={height}
        src={image?.src || ''}
        onClick={onClick}
        imageWidth={width}
      />
    </ImageWrapper>
  );
};

export default ImageZoomStyled;
